/**
 * Shared industry/sector enum - mirrors the backend's
 * `common/constants/industries.ts`. Used by the investor profile's industry
 * preference picker (US-040/US-101).
 */
export const INDUSTRIES = [
  'FinTech',
  'HealthTech',
  'SaaS',
  'E-Commerce',
  'EdTech',
  'CleanTech',
  'Real Estate',
  'AI/ML',
  'Cybersecurity',
  'Biotech',
  'Consumer Goods',
  'Manufacturing',
  'Legal Tech',
  'InsurTech',
  'AgriTech',
  'PropTech',
  'Media & Entertainment',
  'Logistics',
  'Professional Services',
  'Other',
] as const;

export type Industry = (typeof INDUSTRIES)[number];

/** Investor profile industry preferences are capped at this count (US-101 AC3). */
export const MAX_INVESTOR_INDUSTRIES = 10;
